import { createFileRoute } from "@tanstack/react-router";
import AdminAbonnementer from "../../../../pages/AdminAbonnementer";

export const Route = createFileRoute("/_app/account/admin/abonnementer")({
	component: AdminAbonnementer,
});
